<template>
    <div class="page">

        <list-item v-for="data in dataInfo"
                   :key="data.orgID"
                   :first-org-id="firstOrgID"
                   :data-info="data">
        </list-item>


        <div class="list-none" v-if="getIsShowNone">
            <img src="../../../../assets/list-none.png" alt="">
            <div>空荡荡的~暂无数据！</div>
        </div>

    </div>
</template>

<script>
    import ListItem from "./ListItem";
    import axios from "axios";
    import {Message} from 'element-ui';

    export default {

        name: "List",

        components: {
            ListItem
        },

        data() {
            return {
                dataInfo: [],
                firstOrgID: ""
            }
        },

        computed: {
            getIsShowNone() {
                return !(this.dataInfo && this.dataInfo.length > 0);
            }
        },

        created() {
            localStorage.setItem("token", this.$route.query.token || "");
            localStorage.setItem("orgID", this.$route.query.orgID || "");
            localStorage.setItem("type", this.$route.query.client || "");
            document.title = "钥匙管理";
            let url = axios.defaults.baseURL.replace('v1/org/','')
            axios({
                method: 'post',
                url:url+ "v1/users/mkeys/query", 
            }).then(value => {
                if (value.data.data) {
                    this.dataInfo = value.data.data;
                    for(let i = 0;i<value.data.data.length;i++){
                        let lis = value.data.data[i]
                        for(let j =0;j<lis.aptKeys.length;j++){
                            lis.aptKeys[j].orgID = lis.orgID
                        }
                    }
                    if (this.dataInfo && this.dataInfo.length > 0) {
                        this.firstOrgID = this.dataInfo[0].orgID;
                    }
                }
                if (value.data.code !== 0) {
                    Message.error(value.data.message);
                }
            }).catch(reason => {
                Message.error(reason.toString());
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../../pay/page";

</style>
